export default function scrollToElementById(elementId, yOffSet) {
  const element = document.getElementById(elementId);
  const y = element.getBoundingClientRect().top + window.pageYOffset + yOffSet;

  window.scrollTo({ top: y, behavior: "smooth" });
}
